import { useEffect, useState } from 'react'

/** Текущее время, обновляется раз в `everyMs` (по умолчанию 30 с). Для
 *  «старше N минут» в рендере без вызова Date.now() внутри него. */
export function useNow(everyMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), everyMs)
    return () => window.clearInterval(id)
  }, [everyMs])
  return now
}
